export default __webpack_public_path__ + "images/481661ee3e1fea037809b01744d6def9-the-star-entertainment-group.svg";